<template>
  <div class="container-fluid">
    <div class="accordion" id="idAuswahl">
      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingOne-Auswahl">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne-Auswahl" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne-Auswahl">
            Auswahl
          </button>
        </h2>
        <div id="panelsStayOpen-collapseOne-Auswahl" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne-Auswahl">
          <div class="accordion-body">
            <div class="row">
              <div class="col-7 -test1">
                <!-- Grid für Bereich -->
                <areas />
              </div>
              <div class="col-5 -test1">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="accordion" id="idAuswertung" data-bs-parent="#idAuswertung">
      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingOne-Auswertung">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne-Auswertung" aria-expanded="false" aria-controls="panelsStayOpen-collapseOne-Auswertung">
            Anzeigen&nbsp;&nbsp;&nbsp;Pl&auml;ne
            <div class="virtual__button">
              Weiter
            </div>
          </button>
        </h2>
        <div id="panelsStayOpen-collapseOne-Auswertung" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingOne-Auswertung" data-bs-parent="#idAuswertung">
          <div class="accordion-body">
            <div class="row">
              <div class="col-12">
                <DocumentLink />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script language="ts">
import { reactive, ref } from "vue";
import { useStore } from "vuex";
import Areas from "@/components/ControlCenter/Areas"
import { apiPost } from "@/services/api/fetchapi";
import { ProtokollStore } from "@/store/modules/protokollstore";
import DocumentLink  from "@/components/ControlCenter/DocumentLink"

export default {
  name: "DocumentManagement",
  inheritAttrs: false,
  components: {
    Areas,
    DocumentLink
  },
  setup() {
    const store = useStore();

    const request = reactive({
      MonitoringName: ""
    })
    return {
      request,
    }
  }
};
</script>

<style scoped>

.virtual__button {
  text-align: center;
  padding-top: 3px;
  min-width: 90px; 
  max-width: 90px;
  min-height: 26px;
  max-height: 26px;
  margin-left: 20px;
  border: 2px solid rgb(58, 131, 226);
  border-radius: 6px;
  background-color: white;
}

.panel-heading{
  padding: 0px !important; 
}
.test1 {
  border: 2px solid lightcoral;
}
.test2 {
  border: 2px solid lightseagreen;
}
.test3 {
  border: 2px solid lightsteelblue;
}
.test4 {
  border: 2px solid lightgoldenrodyellow;
}
.test5 {
  border: 2px solid goldenrod;
}
.test6 {
  border: 2px solid goldenrod;
}
</style>
